import events from '@wh/quick-deposit/es/main/events';

import { publish, subscribe } from '../patched-message-bus';
import { event3DSecureRequested } from './message-bus-helpers/event3DSecureRequested';
import { eventFailed } from './message-bus-helpers/eventFailed';
import { eventSucceed } from './message-bus-helpers/eventSucceed';

export var ERRORS_MAP = {
  PMT_DECL: { code: 'PAYMENT', message: 'The payment journey failed.' },
  OB_ERR_CUST_GUEST: { code: 'NOT_AUTHORISED', message: 'Is not logged in CAS.' },
  APP_QD_ERR_NO_PMT_METHODS: {
    code: 'INVALID_METHOD',
    message: "The user doesn't have any valid payment methods."
  }
};

export var mapQuickDepositEventsToSiteBaseEvents = function mapQuickDepositEventsToSiteBaseEvents() {
  return [subscribe(events.MESSAGE_PUB_QD_SUCCESS, function (_, _ref) {
    var pmtId = _ref.pmtId,
        depositAmount = _ref.depositAmount,
        balance = _ref.balance;
    return publish(eventSucceed({ pmtId: pmtId, depositAmount: depositAmount, balance: balance }));
  }), subscribe(events.MESSAGE_PUB_QD_FAIL, function (_, _ref2) {
    var code = _ref2.code;

    var error = ERRORS_MAP[code];
    // TODO: SBKS-2403 Maken sure wchich QD events we need to propagate and on which events we need to switch to normal deposit.
    if (!error) {
      // TODO: SBKS-2403 The reason for logging the warning is that we are not aware what errors are possible to receive from QD, so in order to prevent quiet failure it is better to at least notify in the console about it
      // eslint-disable-next-line no-console
      console.warn('Quick Deposit error:', code);
      return;
    }
    publish(eventFailed(error));
  }), subscribe(events.MESSAGE_PUB_QD_INIT3DS, function () {
    return publish(event3DSecureRequested());
  })];
};
//# sourceMappingURL=mappings.js.map